import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, mergeMap, tap } from 'rxjs/operators';
import { AuthService } from '../../shared/services/auth.service';
import { USER_ROLE } from '../../shared/enums/user-role.enum';
import { ToastService } from '../../shared/services/toast.service';

export const adminGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const toastService = inject(ToastService);

  // Try to use the synchronous method first
  const role = authService.getUserRoleFromLocalStorage();

  // If we already have the role, we can return immediately
  if (role !== null) {
    const hasAccess = role === USER_ROLE.ADMIN;

    if (!hasAccess) {
      toastService.showError('Sie haben keine Zugriffsberechtigung für diese Seite');
      router.navigate(['/']);
      return false;
    }

    return hasAccess;
  }

  return false
};
